import { render, staticRenderFns } from "./Sustainability_v2.vue?vue&type=template&id=5ec5e6c0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Sustainability_v2.vue?vue&type=script&lang=js&"
export * from "./Sustainability_v2.vue?vue&type=script&lang=js&"
import style0 from "./Sustainability_v2.vue?vue&type=style&index=0&id=5ec5e6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5e6c0",
  null
  
)

export default component.exports